<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          任务中心
          <span class="titleColor"></span> -任务配置列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <!-- 检索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="任务配置名称">
          <el-input v-model="listQuery.name" placeholder="任务配置名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="listQuery.type" class="filter-item" placeholder="请选择">
            <el-option label="线索任务" value="1" />
            <el-option label="面试任务" value="2" />
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="是否启用">
          <el-select v-model="listQuery.deleted" class="filter-item" placeholder="是否启用">
            <el-option label="启用" value="false" />
            <el-option label="停用" value="true" />
          </el-select>
        </el-form-item>-->

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="el-icon-plus" plan @click="addNewTaskConfig">新增任务配置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表单 -->
      <el-table :data="listData" border class="table">
        <el-table-column prop="id" width="100" label="编号" fixed></el-table-column>
        <el-table-column prop="name" label="任务名称"></el-table-column>

        <el-table-column prop="type" label="任务配置类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type==1">线索任务</span>
            <span v-if="scope.row.type==2">面试任务</span>
          </template>
        </el-table-column>
        <el-table-column prop="isOpen" label="是否开启">
          <template slot-scope="scope">
            <span v-if="scope.row.isOpen==1">是</span>
            <span v-if="scope.row.isOpen==0">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="timeOut" label="超时时间">
          <template slot-scope="scope">{{scope.row.timeOut}}小时</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>

        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
        <!-- <el-table-column prop="updateTime" label="修改时间" :formatter="dateFormat"></el-table-column> -->
        <el-table-column prop label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-view" @click="handleDetail(scope.row.id)">人员安排</el-button>
            <el-button type="text" icon="el-icon-edit" @click="editTaskConfig(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />

      <!-- 新增任务配置 -->
      <el-dialog :title="title" :visible.sync="addVisible" width="700px" center>
        <el-form ref="addTaskForm" :rules="rules" :model="addTaskForm" label-width="160px">
          <el-form-item label="任务配置名称" prop="name">
            <el-input v-model="addTaskForm.name" placeholder clearable></el-input>
          </el-form-item>
          <el-form-item label="任务配置类型" prop="type">
            <el-radio-group v-model="addTaskForm.type">
              <el-radio :label="1">线索任务</el-radio>
              <el-radio :label="2">面试任务</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否开启" prop="isOpen">
            <el-radio-group v-model="addTaskForm.isOpen">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="超时时间" prop="timeOut">
            <el-input
              type="number"
              style="width:180px;"
              v-model="addTaskForm.timeOut"
              placeholder
              clearable
            >
              <template slot="append">小时</template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="是否需要弹窗">
            <el-select v-model="addTaskForm.isAlert" class="filter-item" placeholder="是否要弹窗提醒">
              <el-option label="是" value="1" />
              <el-option label="否" value="0" />
            </el-select>
          </el-form-item>-->

          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              v-model="addTaskForm.remark"
              :rows="7"
              placeholder="请输入备注"
              class="input-width"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAddTaskForm('addTaskForm')">取 消</el-button>
          <el-button type="primary" plan @click="confAddTaskForm('addTaskForm')">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 详情 -->
      <el-dialog title="详情" :visible.sync="detailVisible" width="800px" center>
        <div style="margin:0 40px 20px;">
          <el-button
            @click="configPerson('configPersonForm')"
            type="primary"
            class="el-icon-plus"
          >配置人员</el-button>
        </div>
        <!-- 表单 -->
        <el-table :data="detailList" border class="table">
          <el-table-column prop="id" width="60" label="编号" fixed></el-table-column>
          <el-table-column prop="userName" label="人员"></el-table-column>
          <el-table-column prop="cityNames" label="城市"></el-table-column>
          <el-table-column prop="storeNames" label="渠道"></el-table-column>

          <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat" width="140"></el-table-column>
          <!-- <el-table-column prop="updateTime" label="修改时间" :formatter="dateFormat"></el-table-column> -->
          <el-table-column prop label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="red"
                icon="el-icon-delete"
                @click="delPerson(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" plan @click="detailVisible=false;">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 新增配置人员 -->
      <el-dialog title="配置人员" :visible.sync="configPersonVisible" width="600px" center>
        <el-form
          ref="configPersonForm"
          :rules="personRules"
          :model="configPersonForm"
          label-width="160px"
        >
          <el-form-item label="人员">
            <el-select v-model="configPersonForm.userId" clearable placeholder="请选择人员" filterable>
              <el-option
                v-for="(item,index) in userList"
                :key="index"
                :label="item.userName+item.userAccount"
                :value="item.id+','+item.userName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市">
            <el-select v-model="configPersonForm.cityIds" filterable clearable placeholder="请选择城市" multiple>
              <el-option
                v-for="(item,index) in cityList"
                :key="index"
                :label="item.cityName"
                :value="item.id+','+item.cityName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道">
            <el-select v-model="configPersonForm.storeIds" filterable clearable placeholder="请选择渠道" multiple>
              <el-option
                v-for="(item,index) in stationList"
                :key="index"
                :label="item.name"
                :value="item.id+','+item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAddPersonForm('configPersonForm')">取 消</el-button>
          <el-button type="primary" plan @click="confAddPersonForm('configPersonForm')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import workercrmapi from "@/script/api/workercrmapi";
import wmsApi from "@/script/api/wmsApi";
import taskApi from "@/script/api/taskApi";
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data";
import service from "@/script/api/service";
export default {
  components: { Pagination },
  data() {
    return {
      cityList: [],
      userList: [],
      stationList: [],
      configPersonVisible: false,
      detailList: [],
      detailVisible: false,
      taskId: "",
      taskConfigType: "",
      title: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      listData: [],
      listQuery: {
        type:'',
        name: ""
      },
     
      addVisible: false,
      addTaskForm: {
        name: "",
        isOpen: 1,
        timeOut: "",
        type: 1,
        remark: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入任务配置名称", trigger: "change" }
        ],
        type: [
          { required: true, message: "请选择任务配置类型", trigger: "change" }
        ],
        isOpen: [
          { required: true, message: "请选择是否开启", trigger: "change" }
        ],
        timeOut: [
          { required: true, message: "请输入超时时间", trigger: "change" }
        ]
      },
      configPersonForm: {
        userId: "",
        cityIds: [],
        storeIds: []
      },
      personRules: {
        userId: [{ required: true, message: "请选择人员", trigger: "change" }],
        cityIds: [{ required: true, message: "请选择城市", trigger: "change" }],
        storeIds: [{ required: true, message: "请选择渠道", trigger: "change" }]
      }
    };
  },
  created() {
    this.querySearch();

  },
  methods: {
    //查询
    querySearch() {
      taskApi
        .$axiosTaskConfigPageList({
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          type: this.listQuery.type,
          name: this.listQuery.name
        })
        .then(res => {
          console.log(res);
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleDetail(id) {
      this.taskId = id;
      taskApi
        .$axiosGetCampaginPersonList({
          campaignId: id
        })
        .then(res => {
          console.log(res);
          this.detailList = res.data.data;
          this.detailVisible = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
  
    //取消新增并重置
    cancelAddTaskForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
      this.addVisible = false;
    },
    cancelAddPersonForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
      this.configPersonVisible = false;
     
    },
    configPerson(formName) {
      
      this.configPersonVisible = true;
       this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    
      this.getSysUser();
      this.getAllCity();
      this.getSupplierList();
         this.configPersonForm= {
        userId: "",
        cityIds: [],
        storeIds: []
      };
    },

    getSysUser() {
      service.$axiosSysUsergetallUser().then(res => {
        if (res.data.errno == 0) {
          this.userList = res.data.data;
        }
      });
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity().then(res => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
    getSupplierList() {
      //获取归属
      workercrmapi
        .$axiosGetSupplierList({
          companyId: globalData.company.id,
          filterType: 1
        })
        .then(res => {
          this.stationList = res.data.data;
        });
    },
    //确定新增
    confAddTaskForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.addTaskForm;
          params.id = this.taskId;
          taskApi.$axiosAddOrUpdateCampaign(this.addTaskForm).then(res => {
            console.log(res);
            if (res.data.errno == 0) {
              let msg = this.taskId == "" ? "添加成功" : "编辑成功";
              this.$message.success(msg);
              this.addVisible = false;
              this.querySearch();
            } else {
              this.$message.warning(res.data.data);
            }
          });
        } else {
          console.log("err");
        }
      });
    },
    confAddPersonForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let citys = this.configPersonForm.cityIds;
          let cityIds = [];
          let cityNames = [];
          citys.forEach(item => {
            let list = item.split(",");
            cityIds.push(list[0]);
            cityNames.push(list[1]);
          });
          let stores = this.configPersonForm.storeIds;
          let storeIds = [];
          let storeNames = [];
          stores.forEach(item => {
            let list = item.split(",");
            storeIds.push(list[0]);
            storeNames.push(list[1]);
          });
          let params = {
            campaignId: this.taskId,
            userId: this.configPersonForm.userId.split(",")[0],
            userName: this.configPersonForm.userId.split(",")[1],
            cityIds: cityIds.join(","),
            cityNames: cityNames.join(","),
            storeIds: storeIds.join(","),
            storeNames: storeNames.join(",")
          };

          taskApi.$axiosAddOrUpdateCampaignPerson(params).then(res => {
            console.log(res);
            if (res.data.errno == 0) {
              this.$message.success("添加成功");
              this.configPersonVisible = false;
              this.handleDetail(this.taskId);
            } else {
              this.$message.warning(res.data.data);
            }
          });
        } else {
          console.log("err");
        }
      });
    },

    //新增任务配置
    addNewTaskConfig() {
      this.taskId = "";
      this.title = "新增任务配置";
      this.addTaskForm = {
        name: "",
        isOpen: 1,
        timeOut: "",
        type: 1,
        remark: ""
      };

      this.addVisible = true;
    },
    editTaskConfig(row) {
      this.taskId = row.id;
      this.title = "编辑任务配置";
      this.addTaskForm = {
        name: row.name,
        isOpen: row.isOpen,
        timeOut: row.timeOut,
        type: row.type,
        remark: row.remark
      };

      this.addVisible = true;
    },

    //删除确认框
    delPerson(row) {
      this.$confirm("您确定删除吗？")
        .then(_ => {
          taskApi
            .$axiosDeleteCampaignPerson({
              campaignId: row.campaignId,
              userId: row.userId

            })
            .then(res => {
              if (res.data.errno == 0) {
                this.$message.success("删除成功");
                this.handleDetail(this.taskId);
              } else {
                this.$message.warning(res.data.data);
              }
            });
        })
        .catch(_ => {});
    },

    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined || date == "") {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");
    }
  }
};
</script>
<style scoped>
.el-form {
  padding: 0 60px 0 20px !important;
}

.el-select.el-select--small,
.el-input--small {
  width: 100%;
}
</style>

